import { Component, Input } from '@angular/core';

import { Contact } from '../models/contact.model';
import { AirportComment } from '../models/airport-comment.model';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  @Input() contact: Contact;

  @Input() remarks: Array<AirportComment> = [];

  get type(): string {
    return Contact.formatContactType(this.contact.type);
  }
}
